import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import { storeListSelector } from 'redux/slices/javelinStore';
import NewCompany from 'pages/Onboarding/NewCompany';
import Welcome from 'pages/Onboarding/Welcome';
import { BrandContext } from 'utils/brand-context';

function Home() {
  const brand = useContext(BrandContext);
  const storeCount = useSelector(storeListSelector.selectTotal);
  const hopRedirecting = useSelector((state) => state.company.hopRedirecting);
  const isOnboarding = (!storeCount && brand.hasOnboarding) || hopRedirecting;

  return isOnboarding ? <NewCompany /> : <Welcome />;
}

export default Home;
